import mutations from './occupationHealthCodeStore.mutations'
import actions from './occupationHealthCodeStore.actions'
import getters from './occupationHealthCodeStore.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
